/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Import_Step_MapInputs */

const cs_import_step_map = /** @type {(inputs: Import_Step_MapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mapování`)
};

const en_import_step_map = /** @type {(inputs: Import_Step_MapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Map columns`)
};

/**
* | output |
* | --- |
* | "Map columns" |
*
* @param {Import_Step_MapInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const import_step_map = /** @type {((inputs?: Import_Step_MapInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Import_Step_MapInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_import_step_map(inputs)
	return cs_import_step_map(inputs)
});